export default "__VITE_ASSET__CJCwIs20__"